import React, { useState } from 'react';
import { Volume2, X, Sun, Moon, Accessibility } from 'lucide-react';
import { useThemeContext } from '../../context/ThemeContext';
import { useTTS } from '../../hooks/useTTS';

const AccessibilityControls: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { isDarkMode, toggleTheme } = useThemeContext();
  const { cancel } = useTTS();

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <>
      <div className="fixed bottom-28 right-8 z-50 flex flex-col items-end gap-2">
        {isOpen && (
          <div className="bg-surface border border-border p-4 rounded-xl shadow-2xl mb-2 min-w-[250px] space-y-4 animate-in slide-in-from-bottom-5 fade-in">
            <div className="flex justify-between items-center border-b border-border pb-2">
              <h3 className="font-bold flex items-center gap-2">
                <Accessibility className="w-5 h-5" />
                Easy Access
              </h3>
              <button onClick={() => setIsOpen(false)} className="p-1 hover:bg-muted rounded text-muted-foreground">
                <X className="w-4 h-4" />
              </button>
            </div>

            <div className="space-y-3">


              {/* Dark Mode Toggle */}
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium flex items-center gap-2">
                  {isDarkMode ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
                  {isDarkMode ? 'Dark Mode' : 'Light Mode'}
                </span>
                <button
                  onClick={toggleTheme}
                  className={`w-12 h-6 rounded-full transition-colors flex items-center px-1 ${isDarkMode ? 'bg-primary justify-end' : 'bg-muted justify-start'
                    }`}
                  aria-pressed={isDarkMode}
                >
                  <div className="w-4 h-4 rounded-full bg-white shadow-sm" />
                </button>
              </div>

              {/* Stop Speaking */}
              <button
                onClick={cancel}
                className="w-full flex items-center justify-center gap-2 p-2 rounded-lg bg-red-100 text-red-700 hover:bg-red-200 transition-colors text-sm font-semibold"
              >
                <Volume2 className="w-4 h-4" />
                Stop Reading
              </button>
            </div>

            <p className="text-[10px] text-muted-foreground text-center pt-2">
              Govt. Standard Accessibility
            </p>
          </div>
        )}

        <button
          onClick={toggleOpen}
          className="p-3 rounded-full bg-primary text-primary-foreground shadow-lg hover:scale-105 transition-transform border-2 border-white/20"
          aria-label="Open Accessibility Menu"
          title="Easy Access / Accessibility"
        >
          <Accessibility className="w-6 h-6" />
        </button>
      </div>
    </>
  );
};

export default AccessibilityControls;
